'use strict';

exports.__esModule = true;
exports.default = listNumbers;

var _useReversedNumbers = require('./useReversedNumbers');

var _roundDownToScale = require('./roundDownToScale');

var MAX_ITERATIONS = 1000;

/**
 * Create a list with number numbers from provided start to end number.
 * Will include the first occurrence after end.
 * @param {number} xStart
 * @param {number} xEnd
 * @param {number} step   Must be a positive number
 * @returns {number[]} Returns an array with number numbers
 */
function listNumbers(xStart, xEnd) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  var reverseNumbers = (0, _useReversedNumbers.useReversedNumbers)(xStart, xEnd);
  var start = reverseNumbers ? xEnd : xStart;
  var end = reverseNumbers ? xStart : xEnd;

  var numbers = [];

  var current = (0, _roundDownToScale.roundDownToScale)(start, step);
  do {
    numbers.push(current);
    current += step;
  } while (current < end + step && numbers.length < MAX_ITERATIONS);

  return reverseNumbers ? numbers.reverse() : numbers;
}